import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  root: {
    lineHeight: "24px",
    color: "#fff",
    fontSize: 24,
  },
  iconsList: {
    display: "grid",
    gap: 12,
    "& > p": {
      display: "flex",
    },
  },
});
